import { Box } from '@mantine/core';
import { forwardRef, useEffect } from 'react';
import classes from './taskbar.module.css';
import { data } from './nav_data';
import OfflineBanner from '../offline_banner/offline_banner';
import { usePathname } from 'next/navigation';
import { clsx } from 'clsx';

const TaskBar = forwardRef<HTMLDivElement>((_, ref) => {
  const pathname = usePathname();

  useEffect(() => {
    if (ref && 'current' in ref) {
      const observer = new ResizeObserver(() => {
        window.dispatchEvent(new Event('taskbar-resize'));
      });

      if (ref.current) {
        observer.observe(ref.current);
      }

      return () => observer.disconnect();
    }
  }, [ref]);

  const links = data.map((item) => {
    const isActive = pathname === item.link || pathname.startsWith(item.link + '/');
    
    return (
      <Box
        key={item.link}
        className={clsx(classes.link, { [classes.active]: isActive })}
        component="a"
        href={item.link}
      >
        <item.icon size={24} stroke={1.25} />
        <span className={classes.label}>{item.label}</span>
      </Box>
    );
  });

  return (
    <div ref={ref} className={classes.taskbarContainer}>
      <Box className={classes.taskbar}>
        {links}
      </Box>
      <OfflineBanner />
    </div>
  );
});

TaskBar.displayName = 'TaskBar';

export default TaskBar;
